import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import CustomizedGrid from '../../../../components/base/Grid/CustomizedGrid';
import Pagination from '../../../../components/base/Pagination/Pagination';
import { intlShape } from '../../../../components/base/IntlProviderWrapper';
import { Button, Icons } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  calculatedViewMode,
  getFilterData, getPaginationOpts, responseLogWithNotification, useUpdatePeriod,
} from '../../../../utils/utils';
import { REGION_REGISTRY_MODULE } from '../../../../configs/moduleNames';
import { getSystemData } from '../../../System/reducer';
import FilterRow from '../../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../../components/fields/Abstract/FieldDTO';
import getDefaultSort from '../../../../utils/getDefaultSort';
import { loadCarrierList } from '../../../RegionRegistry/actions';
import { getRegisterData } from '../../../RegionRegistry/reducer';
import { additionalCarrierColumns, carrierColumns } from '../../../RegionRegistry/components/carrierColumns';
import TextSearchInput from '../../../../components/fields/TextInput/TextSearchInput';
import CustomSelectInput from '../../../../components/fields/SelectInput/CustomSelectInput';
import { REGISTRIES_STATUS_LIST } from '../../../../configs';
import FilterModal from '../../../FilterTemplate/components/FilterModal';
import { PAGE_TYPE } from '../../../FilterTemplate/components/filter-settings';
import ApplicationsDTO from '../../../../dto/ApplicationsDTO';
import TimerLoader from '../../../../components/base/Loader/TimerLoader';

export function CarrierBox(props) {
  const { onClose = () => {}, currentApplicant = {} } = props;
  const dispatch = useDispatch();
  const {
    carrierListMeta,
    loadingCarrierList,
    carrierList,
  } = useSelector(getRegisterData);
  const store = useStore();
  const [isOpenFilter, setOpenFilter] = useState(false);
  const DTO = new ApplicationsDTO();
  const attributes = DTO.getAttributesByName();
  const filterName = 'applicant-carrier-list';
  const {
    formatMessage,
  } = intlShape;
  const rowClassFormatter = item => {
    const classes = ['clickable-table-row'];
    return classes.join(' ');
  };

  const loadData = opts => {
    const filterData = getValues();
    const paginationOpts = getPaginationOpts(store.getState()[REGION_REGISTRY_MODULE].carrierListMeta, opts);
    const viewModeData = calculatedViewMode(filterData.view_mode);
    delete filterData.view_mode;
    const requestData = {
      ...paginationOpts,
      filter: {
        ...filterData,
        ...viewModeData,
        applicant_id: currentApplicant?.id,
      },
      sort,
    };
    const p1 = dispatch(loadCarrierList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  const {
    getValues, control, watch, setValue, reset,
  } = useForm({ defaultValues: getFilterData(filterName, {}) });
  const { updatePeriod } = useSelector(getSystemData);
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);

  useEffect(() => {
    const subscription = watch(values => {
      localStorage.setItem(filterName, JSON.stringify(values));
      loadData({ page: 1 });
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const moreFormatter = (_, item) => (
    <Icons customIcon icon="more-vert" className="more-vert" />
  );

  const [sort, setSort] = useState(getDefaultSort(carrierColumns));

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => { loadData(); }, [sort]);

  const handleOpenTab = item => {
    window.open(`/region-registry-carrier?registry_id=${item?.id}`, '_blank');
  };

  return (
    <div className="applicant-body flex-column">
      <TimerLoader loading={loadingCarrierList} />
      <div className="applicant-title">
        <Icons width={24} height={24} customIcon icon="arrow-return" onClick={onClose} />
        <div className="f3">{formatMessage({ id: 'applicant.card.menu.carrier' })}</div>
        <FilterRow>
          <FieldDTO
            control={control}
            component={TextSearchInput}
            dtoObject={{
              name: 'search',
              type: String,
              labelKey: 'search',
            }}
          />
          <FieldDTO
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.status}
            usePortal
            placeholder="Статус"
            options={REGISTRIES_STATUS_LIST}
            addPlaceholder
            multiple
          />
          {isOpenFilter
            ? (
              <FilterModal
                control={control}
                onClose={() => setOpenFilter(false)}
                getValues={getValues}
                reset={reset}
                defaultValues={{}}
                page={PAGE_TYPE.REGION_REGISTRY_CARRIER}
              />
            )
            : null}
          <div className="filter-sep" />
          <Button variant="second" onClick={() => setOpenFilter(true)}>
            <Icons customIcon className="file-download" width={24} height={24} icon="filter" />
          </Button>
        </FilterRow>
      </div>
      <div className="grid-wrapper frame">
        <div className="custom-scroll-theme sticky-table-wrapper custom">
          <CustomizedGrid
            data={carrierList}
            columns={carrierColumns}
            onDoubleClickByRow={item => handleOpenTab(item)}
            additionalColumns={additionalCarrierColumns}
            name="carrier-grid"
            changeSort={changeSort}
            sort={sort}
            rowClassFormatter={rowClassFormatter}
            settingsFormatter={moreFormatter}
          />
        </div>
        <Pagination meta={carrierListMeta} list={carrierList} handleChangeMeta={loadData} />
      </div>
    </div>
  );
}
